import { ComboBoxColumnConfig } from '@core/interfaces';

export const columnsDefaultConfig: ComboBoxColumnConfig = {
  column1: {
    dropdown: {
      key: 'column1',
      display: true,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column1',
      display: true,
      width: 100,
      class: '',
    },
  },

  // this column automatically sizes to fill
  // any available space by default (width: 0)
  column2: {
    dropdown: {
      key: 'column2',
      display: true,
      width: 0,
      class: '',
    },
    popup: {
      key: 'column2',
      display: true,
      width: 0,
      class: '',
    },
  },

  // all columns after column2 are not displayed by default
  column3: {
    dropdown: {
      key: 'column3',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column3',
      display: false,
      width: 100,
      class: '',
    },
  },
  column4: {
    dropdown: {
      key: 'column4',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column4',
      display: false,
      width: 100,
      class: '',
    },
  },
  column5: {
    dropdown: {
      key: 'column5',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column5',
      display: false,
      width: 100,
      class: '',
    },
  },
  column6: {
    dropdown: {
      key: 'column6',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column6',
      display: false,
      width: 100,
      class: '',
    },
  },
  column7: {
    dropdown: {
      key: 'column7',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column7',
      display: false,
      width: 100,
      class: '',
    },
  },
  column8: {
    dropdown: {
      key: 'column8',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column8',
      display: false,
      width: 100,
      class: '',
    },
  },
  column9: {
    dropdown: {
      key: 'column9',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column9',
      display: false,
      width: 100,
      class: '',
    },
  },
  column10: {
    dropdown: {
      key: 'column10',
      display: false,
      width: 100,
      class: '',
    },
    popup: {
      key: 'column10',
      display: false,
      width: 100,
      class: '',
    },
  },
};
